import { render, staticRenderFns } from "./InputProvider.vue?vue&type=template&id=18d47130&scoped=true&"
import script from "./InputProvider.vue?vue&type=script&lang=js&"
export * from "./InputProvider.vue?vue&type=script&lang=js&"
import style0 from "./InputProvider.vue?vue&type=style&index=0&id=18d47130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d47130",
  null
  
)

export default component.exports